export function getCatalogTourSteps(isMobile = false) {
  if (isMobile) {
    return [
      {
        target: '[data-testid="catalog-nav-tabs"]',
        title: "כרטיסיות הניווט",
        content: "כאן תוכלו לעבור בין סוגי המודעות השונות: מודעות חדשות, כל המודעות וארכיון. בחרו את הלשונית הרצויה כדי לראות את הרכבים הרלוונטיים עבורכם.",
        placement: "bottom",
      },
      {
        target: '[data-testid="filter-toggle-btn-mobile"]',
        title: "סינון לפי הצרכים שלך",
        content: "במובייל לחצו על כפתור הפילטרים כדי לפתוח את אזור הסינון ולמצוא רכבים לפי מחיר, יצרן, דגם, שנה וסוג הרכב.",
        placement: "left",
      },
      {
        target: '[data-testid="vehicle-card"]:first-child',
        title: "כרטיס הרכב",
        content: "כל כרטיס מציג: תמונות, שם הרכב, שנה, יצרן, סוג דלק, תיבת ההילוכים, **ומחיר מינימום** - הסכום הנמוך ביותר שהספק יסכים לו.",
        placement: "top",
      },
      {
        target: '[data-testid="status-badge"]',
        title: "הסטטוס של הרכב",
        content: '**"ממתין להצעה"** - הרכב עדיין פתוח לקבלת הצעות. **"ממתין לאישור"** - הצעות כבר נשלחו לספק.',
        placement: "top",
      },
      {
        target: '[data-testid="vehicle-card"]:first-child',
        title: "מוכנים? נכנסים לרכב הראשון",
        content: "**לחצו על כרטיס הרכב** כדי לראות את הפרטים המלאים ולהגיש הצעה. **בואו ננסה!**",
        placement: "top",
      },
    ];
  }

  return [
    {
      target: '[data-testid="catalog-nav-tabs"]',
      title: "כרטיסיות הניווט",
      content: "כאן תוכלו לעבור בין סוגי המודעות השונות: מודעות חדשות, כל המודעות וארכיון. בחרו את הלשונית הרצויה כדי לראות את הרכבים הרלוונטיים עבורכם.",
      placement: "bottom",
    },
    {
      target: '[data-testid="catalog-filters"]',
      title: "סינון לפי הצרכים שלך",
      content: "סננו לפי מחיר, יצרן, דגם, שנת יצור, וסוג הרכב (פרוק/שיקום). כך תמצאו רק את הרכבים הרלוונטיים לכם.",
      placement: "bottom",
    },
    {
      target: '[data-testid="vehicle-card"]:first-child',
      title: "כרטיס הרכב",
      content: "כל כרטיס מציג: תמונות, שם הרכב, שנה, יצרן, סוג דלק, תיבת הילוכים, **ומחיר מינימום** — הסכום הנמוך ביותר שהספק יסכים לו.",
      placement: "top",
    },
    {
      target: '[data-testid="status-badge"]',
      title: "הסטטוס של הרכב",
      content: '**"ממתין להצעה"** — הרכב עדיין פתוח לקבלת הצעות. **"ממתין לאישור"** — הצעות כבר נשלחו לספק.',
      placement: "top",
    },
    {
      target: '[data-testid="my-ads-dealer-panel"]',
      title: "פאנל הצד",
      content: "כאן תמיד תראו כמה רכבים חדשים עלו היום וכמה הצעות שלכם ממתינות — מיד בכניסה.",
      placement: "right",
    },
    {
      target: '[data-testid="vehicle-card"]:first-child',
      title: "מוכנים? נכנסים לרכב הראשון",
      content: "**לחצו על כרטיס הרכב** כדי לראות את הפרטים המלאים ולהגיש הצעה. **בואו ננסה!**",
      placement: "top",
    },
  ];
}

const catalogTourSteps = getCatalogTourSteps(false);
export default catalogTourSteps;
